module.exports = __webpack_public_path__ + "static/survival_years-c07904c17a349259b4fb5cd0d3c5dce5.jpg";